<template>
  <main class="page-main location">
    <section class="page-heading-wrap location-heading-wrap">
      <h3 class="page-heading">{{ $t('location.head') }}</h3>
      <p class="page-heading-desc">{{ $t('location.copy') }}</p>
    </section>

    <section>
      <div class="map">
        <iframe
          width="700"
          height="360"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d791.15510014794!2d127.11224712920496!3d37.51687026246756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca5702e821a51%3A0x9a907781e11dd2ac!2z7ISc7Jq47Yq567OE7IucIOyGoe2MjOq1rCDsnITroYDshLHrjIDroZwgMg!5e0!3m2!1sko!2skr!4v1487643218383"
        />
      </div>
      <ul class="location-list">
        <li>
          <p class="location-list-title">Address</p>
          <div class="location-list-cont">
            <html-view :value="$t('location.address')" tag="address" />
            <em>{{ $t('location.address2') }}</em>
          </div>
        </li>
        <li>
          <p class="location-list-title">TEL</p>
          <div class="location-list-cont"><a href="tel:02-1600-7001">1600-7001</a></div>
        </li>
        <li>
          <p class="location-list-title">FAX</p>
          <div class="location-list-cont">050-6050-0400</div>
        </li>
        <li>
          <p class="location-list-title">E-mail</p>
          <div class="location-list-cont"><a href="mailto:help@woowahan.com">help@woowahan.com</a></div>
        </li>
      </ul>
    </section>
  </main>
</template>
<script>
export default {
  components: {},
}
</script>
